import React from "react";
import { useNavigate } from "react-router-dom";
import Button from 'react-bootstrap/CloseButton';

export default function MonBtn({children}) {
  const navigate = useNavigate();
  



  return (
    <div>
      <button className="btn btn-primary btn-lg" onClick={() => navigate(-1)}>
        {children}
      </button>
    </div>
  );
}
